import React from 'react'
import TextField from 'lib/ui/TextField'
import Dialog from 'lib/ui/Dialog'
import {AssistantThread} from 'lib/obie/use-assistant'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import Box from '@material-ui/core/Box'
import styled from 'styled-components'
import Button from 'lib/ui/Button'
import {DarkThemeProvider} from 'lib/ui/theme/ThemeProvider'
import {useUpdateAssistantThread} from 'lib/obie/use-update-assistant-thread'

export interface AssistantThreadTitleDialogProps {
  thread: AssistantThread | null
  isOpen: boolean
  onClose: () => void
}

export default function AssistantThreadTitleDialog({
  thread,
  isOpen,
  onClose,
}: AssistantThreadTitleDialogProps) {
  const [title, setTitle] = React.useState(thread?.title || 'New Chat')

  const updateThread = useUpdateAssistantThread()

  React.useEffect(() => {
    if (thread) {
      setTitle(thread.title || 'New Chat')
    }
  }, [thread])

  if (!thread) return null

  const save = () => {
    updateThread.mutate({
      id: thread.id,
      title,
      assistant_id: thread.assistant_id,
    })

    onClose()
  }

  return (
    <DarkThemeProvider>
      <Dialog open={isOpen} title="Edit Chat Title" onClose={onClose}>
        <DialogTitle>Edit Thread Title</DialogTitle>
        <DialogContent>
          <TextField
            fullWidth
            value={title}
            onChange={setTitle}
            placeholder="Enter chat title"
            // autoFocus
            inputProps={{
              'aria-label': 'thread title',
            }}
          />
          <Box display="flex" justifyContent="flex-end">
            <SaveButton
              color="primary"
              variant="contained"
              onClick={save}
              disabled={updateThread.isLoading}
            >
              Save
            </SaveButton>
          </Box>
        </DialogContent>
      </Dialog>
    </DarkThemeProvider>
  )
}

const SaveButton = styled(Button)`
  margin-bottom: ${(props) => props.theme.spacing[4]}!important;
`
